<template>
    <div class="">

        <div class="" id="nav-tabContent-intro">

            <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Loan & Advance Reports<span>
                <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Loan & Advance Reports</span>
            </h4>
            <p style="font-size: 15px;" class="text-secondary pt-4">Get a clear picture of your KPI Report. Use this information to better understand your workforce.</p>
            <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav">
                <b-tab>
                    <template #title>
                        <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                            <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                            <h5>Loan & Advance Schedule for Indvidual</h5>
                            <p>This report shows total breakdown of any selected month's payroll including all pay and allowances and deductions per employee.</p>
                            <b-button class="btn btn-primary">View Report</b-button>
                        </div>
                    </template>
                    <div>
                        <loan-schedule-report ></loan-schedule-report>
                    </div>
                </b-tab>
                <b-tab>
                    <template #title>
                        <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                            <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                            <h5>Loan & Advance Balance</h5>
                            <p>This report shows the aggregate breakdown of any selected period's Loan & Advance Balance per employee.</p>
                            <b-button class="btn btn-primary">View Report</b-button>
                        </div>
                    </template>
                    <div>
                        <loan-monthly-report ></loan-monthly-report>

                    </div>
                </b-tab>

            </b-tabs>

        </div>
       </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: [ 'flag'],
        components: {

        },
        data(){

            return {



                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Fetching data..',

                fiscal_year : '',

                payroll_reporting_data : [],

            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            openMe: function()
            {
                this.$bvModal.show('view-details');
            },

        },
        created: function(){
            this.fiscal_year = this.getCurrentFinancialYear();
        },
        computed:
        {

        }
    }
</script>
<style>
.pf-reporting-tab .nav-item {
	width: 23% !important;
}
</style>
